import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const deleteBranch = createAsyncThunk(
    'editBranchForm/deleteBranch',
    async ({branchId, token}) => {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/branches/${branchId}/delete`,
            {
                method: 'DELETE',
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        .then(response => response.json());
        return response;
    }
)

export const updateBranch = createAsyncThunk(
    'editBranchForm/updateBranch',
    async ({branchToUpdate, token}) => {
        const requestBody = JSON.stringify(branchToUpdate);
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/branches/update`,
            {
                method: 'PUT',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: requestBody
            }
        )
        .then(response => response.json());
        return response;
    }
)

export const editBranchFormSlice = createSlice({
    name: 'editBranchForm',
    initialState: {
        branchId: '',
        branchName: '',
        active: false,
        confirmingUpdateBranch: false,
        updatingBranch: false,
        failedToUpdateBranch: false,
        confirmingDeleteBranch: false,
        deletingBranch: false,
        failedToDeleteBranch: false,
        status: ''
    },
    reducers: {
        changeEditBranchId: (state, action) => {
            return {
                ...state,
                branchId: action.payload
            }
        },
        changeEditBranchName: (state, action) => {
            return {
                ...state,
                branchName: action.payload
            }
        },
        changeEditBranchFormStatus: (state, action) => {
            return {
                ...state,
                status: action.payload
            }
        },
        toggleEditBranchForm: (state) => {
            return {
                ...state,
                active: !state.active
            }
        },
        clearEditBranchForm: (state) => {
            return {
                ...state,
                branchId: '',
                branchName: '',
                status: ''
            }
        },
        setConfirmingBranchUpdate: (state, action) => {
            return {
                ...state,
                confirmingUpdateBranch: action.payload
            }
        },
        setConfirmingBranchDelete: (state, action) => {
            return {
                ...state,
                confirmingDeleteBranch: action.payload
            }
        }
    },
    extraReducers: {
        [deleteBranch.pending]: (state) => {
            return {
                ...state,
                deletingBranch: true,
                failedToDeleteBranch: false
            }
        },
        [deleteBranch.fulfilled]: (state) => {
            return {
                ...state,
                deletingBranch: false,
                failedToDeleteBranch: false
            }
        },
        [deleteBranch.rejected]: (state) => {
            return {
                ...state,
                deletingBranch: false,
                failedToDeleteBranch: true
            }
        },
        [updateBranch.pending]: (state) => {
            return {
                ...state,
                updatingBranch: true,
                failedToUpdateBranch: false
            }
        },
        [updateBranch.fulfilled]: (state) => {
            return {
                ...state,
                updatingBranch: false,
                failedToUpdateBranch: true
            }
        }
    }
})

export const selectEditBranchFormBranchId = (state) => state.editBranchForm.branchId;
export const selectEditBranchFormBranchName = (state) => state.editBranchForm.branchName;
export const editBranchFormIsActive = (state) => state.editBranchForm.active;
export const editBranchStatus = (state) => state.editBranchForm.status;
export const selectConfirmingBranchUpdate = (state) => state.editBranchForm.confirmingUpdateBranch;
export const branchUpdating = (state) => state.editBranchForm.updatingBranch;
export const selectConfirmingBranchDelete = (state) => state.editBranchForm.confirmingDeleteBranch;
export const branchDeleting = (state) => state.editBranchForm.deletingBranch;

export const { changeEditBranchId, changeEditBranchName, changeEditBranchFormStatus, toggleEditBranchForm, clearEditBranchForm, setConfirmingBranchDelete, setConfirmingBranchUpdate } = editBranchFormSlice.actions;

export default editBranchFormSlice.reducer;